/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_H1Inputs */

const en_csv_to_json_ref_h1 = /** @type {(inputs: Csv_To_Json_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV input`)
};

const ko_csv_to_json_ref_h1 = /** @type {(inputs: Csv_To_Json_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 입력`)
};

const ja_csv_to_json_ref_h1 = /** @type {(inputs: Csv_To_Json_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 入力`)
};

/**
* | output |
* | --- |
* | "CSV input" |
*
* @param {Csv_To_Json_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_h1 = /** @type {((inputs?: Csv_To_Json_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_h1(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_h1(inputs)
	return ja_csv_to_json_ref_h1(inputs)
});